import { useEffect, useState } from "react";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { useTranslation } from "react-i18next";
import { CollectionView } from "@grapecity/wijmo";
import { cloneDeep } from "lodash";

import BasicStaticGridScreenType from "../screenTypes/functional/BasicStaticGridScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";

import AutoForm from "../form/functional/AutoForm";
import Button from "../input/Button";

import checkValidation from "../../lib/utils/checkValidation";
import getSpecific from "../../lib/api/getSpecific";

function TkFailedLot(props) {

    const { t } = useTranslation();

    const { notifyWarning, onChangeFailedLotList, productionQty } = props;

    const [ grid, setGrid ] = useState();
    const [ formData, setFormData ] = useState();
    const [ failedLotList, setFailedLotList ] = useState([]);
    const [ collectionView, setCollectionView ] = useState();


    useEffect(()=> {
        setFormData({failureCode : '', decisionName : '', qty : ''})
    },[])

    const schema = {

        name: "FailedLot",
        type: "BASE TABLE",
        searchAll: false,

        columns: [

            {
                name: "failureCode",
                type: "varchar(50)",
                formOrder: 1,
                formItemType: "autocomplete",
                codeInfo: {
                    tableName: "MomSysVwProcessingFailureCode",
                    nameColumn: ["decisionCode","decisionName"],
                    valueColumn: "decisionCode",
                    seperator: ": ",
                    useEmptyValue: true,
                    emptyName: "term.none",
                    sortByName: true,
                },
                grid: {
                    columnOrder: 1,
                },
                visible: true,
                width: "100%",
                validation: false
            },
            {
                name: "decisionName",
                type: "varchar(50)",
                hideInForm : true,
                grid: {
                    columnOrder: 2,
                },
                visible: true,
                width: "100%",
                validation: false
            },
            {
                name: "qty",
                type: "float",
                formOrder: 3,
                formItemType: "float",
                grid: {
                    type : "number",
                    columnOrder: 3,
                },
                visible: true,
                width: "100%",
            },

        ]

    };

    useEffect(() => {

        let collectionView = new CollectionView(failedLotList);

        setCollectionView(collectionView);
        
    }, [failedLotList]);

    const onChangeForm = async ( formData ) => {

        let result = await getSpecific("MomSysUdtDecisionCode", formData?.failureCode);

        setFormData({...formData , decisionName : result.decisionName });

    };

    const addFailedLot = ( formData, productionQty ) => {

        if ( ! checkItemValidataion ( formData, productionQty ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (formData.failureCode && formData.qty) {

            setFailedLotList ( ( failedLotList ) => {
    
                let lotList = cloneDeep ( failedLotList );
                
                let lotInList = false;
    
                for ( const lot of lotList ) {
    
                    if ( lot.failureCode === formData.failureCode ) {
                        lot.qty += parseFloat ( formData.qty );
                        lotInList = true;
    
                    }
    
                }
    
                if ( !lotInList ) {
    
                    lotList.push ( { ...formData, qty: parseFloat ( formData.qty ) } );
    
                }
                
                if ( onChangeFailedLotList ) {
    
                    onChangeFailedLotList ( lotList );
        
                }
    
                return lotList;
    
            } );
        }

    };

    const deleteFailedLot = ( ( grid, failedLotList ) => {

        let lotList = cloneDeep ( failedLotList );

        if ( ! grid || ! grid.selectedItems ) {

            return;

        }

        for ( const item of grid.selectedItems ) {

            lotList = lotList.filter ( ( lot ) => lot.failureCode !== item.failureCode );

        }

        setFailedLotList ( lotList );

        if ( onChangeFailedLotList ) {

            onChangeFailedLotList ( lotList );

        }

    } );

    const checkItemValidataion = ( formData, productionQty ) => {

        let totalQty = formData.qty;

        for ( let row of failedLotList ) {

            totalQty += row.qty;

        }

        if ( productionQty > 0 && totalQty > productionQty ) {

            if ( notifyWarning ) {

                notifyWarning ( t ( "warning.cannotMoreThanResultLotQty" ) );

            }

            return false;

        }

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "edit", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                if ( notifyWarning ) {

                    notifyWarning ( msg );

                }

                return false;

            }
            
        }

        return true;

    }

    const onGridInitialized = ( grid ) => {

        setGrid ( grid );

    }

    return (

        <>
            <ReflexContainer orientation="vertical">

                <ReflexElement flex={0.7} >

                    <BasicStaticGridScreenType                        
                        id="FailedLotList"
                        headerTitle={t("term.failedLotList")}
                        schema={schema}
                        itemsSource={collectionView}
                        onAppendButton={ () => (
                            <>
                                <ToolbarFlexSpacer xs />

                                <BasicCrudScreenActionItemLayout>

                                    <Button                            
                                        id="DeleteFailedLot"
                                        color="secondary"
                                        disabled={failedLotList.length < 1}
                                        onClick={ () => deleteFailedLot ( grid, failedLotList ) }
                                    >
                                        {t("buttonName.delete")}
                                    </Button>

                                </BasicCrudScreenActionItemLayout>
                            </>
                        ) }
                        onInitialized={onGridInitialized}
                    />

                </ReflexElement>

                <ReflexSplitter
                    style={{border: "none", width: "1px",color:"lightgray"}}
                />

                <ReflexElement flex={0.3} >

                    <div style={{padding: "16px"}}>

                        <div style={{paddingBottom: "8px"}}>

                            <AutoForm
                                id="input-bonus-loss-form"
                                initialData={formData}
                                schema={schema}
                                mode="edit"
                                onChange={ onChangeForm }
                            />

                        </div>

                        <Button id="AddFailedLot" color="primary" style={{float: "right"}} onClick={() => addFailedLot ( formData, productionQty )}>{t("buttonName.addFailedLot")}</Button>

                    </div>

                </ReflexElement>

            </ReflexContainer>


        </>

    )

}

export default TkFailedLot;
